module.exports = __webpack_public_path__ + "img/amphiteatre-cogeco.c33c2848.png";